<template>
  <div class="index" v-if="data.style" :style="'position: relative;background-image:url('+oss+data.style.backgroundImage+');background-color:'+data.style.backgroundColor">
    <div class="top_btn">
      <div style="margin-bottom:14px" v-if="data.params.is_show_center">导购中心</div>
      <div>活动规则</div>
    </div>
    <div class="top_btn left" v-if="data.params.is_show_goods">
      <div>导购积分商城</div>
    </div>
    <div class="shakeImg" :class="data.style.shake_img_type==0?'shakeImgMask':''" v-if="data.params.is_show_shake&&data.style.shakeBackgroundImage">
      <img :src="oss+data.style.shakeBackgroundImage+'?id=2'" alt="">
    </div>
  </div>
</template>

<script>
import config from "@/config";
export default {
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 337px;
  height: 667px;
  background-size: 100%;
  background-repeat: no-repeat;
  .shakeImg{
    position:absolute;
    width:137.5px;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    img{
     width:137.5px;
    }
  }
  .shakeImgMask{
    width:137.5px;
    height:137.5px;
    background-color: rgba(0,0,0,.5);
    border-radius: 100%;
  }
  .top_btn {
    position: absolute;
    right: 0;
    top: 21px;
    color: #ff211d;
    > div {
      width: 80px;
      height: 24px;
      background: rgba(250, 250, 250, 0.6);
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      text-align: center;
      line-height: 24px;
      margin-bottom: 5px;
    }
  }
  .left {
    left: 0;
    > div {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
    }
  }
  .dm {
    position: absolute;
    bottom: 150px;
    width: 211px;
    height: 30px;
    border-radius: 0px 15px 15px 0px;
    background-color: rgba(250, 250, 250, 0.6);
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #af1817;
    padding-left: 14px;
    img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>